var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.83871C1 3.16637 3.16637 1 5.83871 1H15.5161C18.1885 1 20.3548 3.16637 20.3548 5.83871V15.5161C20.3548 18.1885 18.1885 20.3548 15.5161 20.3548H5.83871C3.16637 20.3548 1 18.1885 1 15.5161V5.83871Z",
    stroke: "white",
    strokeWidth: 1.55087
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1129 10.879C15.1129 13.2173 13.2173 15.1129 10.879 15.1129C8.54072 15.1129 6.64515 13.2173 6.64515 10.879C6.64515 8.54068 8.54072 6.64511 10.879 6.64511C13.2173 6.64511 15.1129 8.54068 15.1129 10.879Z",
    stroke: "white",
    strokeWidth: 1.55087
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3226,
    cy: 5.43548,
    r: 1.20968,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/Insta.6248f0b2aecc4da8b9c870eddf7cd705.svg";
export { ForwardRef as ReactComponent };